import { createFileRoute } from "@tanstack/react-router";
import PlayerDashboard from "@/pages/PlayerDashboard";

export const Route = createFileRoute("/_authenticated/dashboard")({
  head: () => ({
    meta: [
      { title: "Dashboard | De Hussel App" },
      { name: "description", content: "Je persoonlijke dashboard met aankomende hussel-sessies en je baanindeling." },
      { property: "og:title", content: "Dashboard | De Hussel App" },
      { property: "og:description", content: "Je persoonlijke dashboard met aankomende hussel-sessies en je baanindeling." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: PlayerDashboard,
});
